/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OnboardingInternalRouteRequest} from '@cash-web/protos/squareup/cash/usher/api/v1/onboarding_internal_nav.pb'
import {OnboardingInternalRouteResponse} from '@cash-web/protos/squareup/cash/usher/api/v1/onboarding_internal_nav.pb'


export const onboardingInternalRoute = (request:OnboardingInternalRouteRequest, options?: CashRequestOptions) => post<OnboardingInternalRouteRequest, OnboardingInternalRouteResponse>("/cash-app/onboarding/1.0/get-next-route", request, {...options, rejectOnError: true })